import { useCallback, useState } from "react";
import { NEAR_BOTTOM_THRESHOLD_PX } from "./scroll-controller-constants";

export interface ScrollNearBottomState {
  isNearBottom: boolean;
  showJumpToLatest: boolean;
  setShowJumpToLatest: (show: boolean) => void;
  updateNearBottom: () => void;
}

interface UseScrollNearBottomStateInput {
  scrollRef: React.RefObject<HTMLDivElement | null>;
}

export function useScrollNearBottomState({
  scrollRef,
}: UseScrollNearBottomStateInput): ScrollNearBottomState {
  const [isNearBottom, setIsNearBottom] = useState(true);
  const [showJumpToLatest, setShowJumpToLatest] = useState(false);

  const updateNearBottom = useCallback(() => {
    const el = scrollRef.current;
    if (!el) return;

    const distanceFromBottom =
      el.scrollHeight - (el.scrollTop + el.clientHeight);
    const nearBottomNow = distanceFromBottom < NEAR_BOTTOM_THRESHOLD_PX;
    setIsNearBottom(nearBottomNow);
    if (nearBottomNow) {
      setShowJumpToLatest(false);
    }
  }, [scrollRef]);

  return {
    isNearBottom,
    showJumpToLatest,
    setShowJumpToLatest,
    updateNearBottom,
  };
}
